module.exports = __webpack_public_path__ + "static/media/Lausanne.03417980.png";